import { render } from "./SpecialtyServices.vue?vue&type=template&id=dda46266&scoped=true"
import script from "./SpecialtyServices.vue?vue&type=script&lang=js"
export * from "./SpecialtyServices.vue?vue&type=script&lang=js"

import "./SpecialtyServices.vue?vue&type=style&index=0&id=dda46266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda46266"]])

export default __exports__